import { ScriptAnswerInput, ScriptQuestion } from '@vette/data-access';

export const validations = {
  getPrecknockoutAnswersValidator: (knockoutQuestions: ScriptQuestion[]) => [
    {
      validator: (_: unknown, value: ScriptAnswerInput[] | undefined) => {
        const questionsIdsProvided = (value || []).map(
          scriptAnswer => scriptAnswer.scriptQuestionId
        );
        const questionsIdsRequired = knockoutQuestions.map(
          question => question.id
        );

        const isFullMatch =
          questionsIdsProvided.length === questionsIdsRequired.length &&
          questionsIdsProvided.every(id => questionsIdsRequired.includes(id));

        if (!isFullMatch) {
          return Promise.reject(`Please provide answers to all the questions`);
        }

        return Promise.resolve();
      },
    },
  ],
};
